import { PaymentDetailsScreen } from '@/modules/payments';

export default PaymentDetailsScreen;
